import { GetCoexistenceUISessionInfoQuery, QueryOutputType } from '../type/QueryType';
import { graphqlOperationWithTokenRefresh } from './graphqlOperation';

const query = /* GraphQL */ `
	query GetCoexistenceUISessionInfo($id: ID!) {
		getCoexistenceUISessionInfo(id: $id) {
			offsegCompanyName
			offsegUserName
			offsegPermissionName
			g500LiteAuthority
		}
	}
`;

/**
 * セッション情報取得APIを呼び出す
 */
export const queryGetSessionInfo = async (authorizationToken: string): Promise<QueryOutputType<GetCoexistenceUISessionInfoQuery>> => {
	const apiResponse = await graphqlOperationWithTokenRefresh<GetCoexistenceUISessionInfoQuery>(query, { id: authorizationToken }, authorizationToken);
	console.log(apiResponse);

	return apiResponse;
};
